import React from 'react';
import LoaderIcon from '../../assets/icons/loader.svg';

function Loader() {
  return <img src={LoaderIcon} width="80px" alt="Loading Icon" />;
}

export default Loader;
